import type { HybrisPointOfService } from '../../models/hybris/hybrisPointOfService';
import type { HybrisCoopStoreSimple } from '../../models/hybris/hybrisStore';

import { HybrisResponseFieldsType } from '../../models/hybris/hybrisConstants';
import getDirectHybrisAxiosClient from '../clients/directHybrisAxiosClient';
import { getCancellationToken } from '../utils';
import { deliveryStoreErrorInterceptor } from './directStoreApiErrorInterceptors';

export const directStoreApiUrls = {
    getPointOfService: (id: string) => `/pointofservice/${encodeURIComponent(id)}`,
    getPointOfServices: `/pointofservices`,
    getStoreByPostCode: `/coopstore`,
    getStoresByPostCode: `/coopstores`,
} satisfies {
    [k in keyof typeof directStoreApi]: `/${string}` | ((...args: string[]) => `/${string}`);
};

const getPointOfService = async (id: string) => {
    const response = await getDirectHybrisAxiosClient(undefined).get<HybrisPointOfService>(
        directStoreApiUrls.getPointOfService(id),
        { params: { fields: HybrisResponseFieldsType.Full } },
    );
    return response.data;
};

const getPointOfServices = async (query: string | undefined, abortSignal?: AbortSignal) => {
    const cancelToken = getCancellationToken(abortSignal);

    const response = await getDirectHybrisAxiosClient(undefined).get<{
        stores: HybrisPointOfService[];
    }>(directStoreApiUrls.getPointOfServices, {
        cancelToken,
        params: {
            query,
            fields: HybrisResponseFieldsType.Full,
        },
    });
    return response.data;
};

// fields=FULL should return full store but it doesnt, confirmed its a bug in hybris
const getStoreByPostCode = async (postCode: string) => {
    const response = await getDirectHybrisAxiosClient(undefined, [
        deliveryStoreErrorInterceptor,
    ]).get<HybrisCoopStoreSimple>(directStoreApiUrls.getStoreByPostCode, {
        params: { fields: HybrisResponseFieldsType.Basic, postCode },
    });
    return response.data;
};

// fields=FULL should return full store but it doesnt, confirmed its a bug in hybris
const getStoresByPostCode = async (postCode: string) => {
    const response = await getDirectHybrisAxiosClient(undefined, [
        deliveryStoreErrorInterceptor,
    ]).get<{
        stores: HybrisCoopStoreSimple[];
    }>(directStoreApiUrls.getStoresByPostCode, {
        params: { fields: HybrisResponseFieldsType.Basic, postCode },
    });
    return response.data.stores;
};

export const directStoreApi = {
    getPointOfService,
    getPointOfServices,
    getStoreByPostCode,
    getStoresByPostCode,
};
